import React, { Component } from "react";
import axios from "axios";
import { message } from "antd";
import "./style.css";

export default class Chronicles extends Component {
  state = {
    yearList: [],
    chooseYear: null,
    memoirList: [],
    loading: false,
  };

  componentDidMount() {
    this.initMemorabiliaData();
  }

  initMemorabiliaData = () => {
    this.setState({ loading: true, memoirList: [] }, async () => {
      await axios
        .get(`/gateway/api/demo-service/memoir/getyears`)
        .then((year) => {
          let yearList = year.data.payload.reverse();
          if (yearList.length > 0) {
            this.setState({ yearList, chooseYear: yearList[0] }, async () => {
              await axios
                .get(
                  `/gateway/api/demo-service/memoir/getbylist?year=${this.state.chooseYear}`
                )
                .then((res) => {
                  let data = res.data.payload.sort((a, b) => b.month - a.month);
                  this.setState({
                    memoirList: data,
                  });
                });
            });
          } else {
            this.setState({ memoirList: [] });
          }
        })
        .catch((e) => {
          message.error("获取数据失败");
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    });
  };

  handleChange = (year) => {
    this.setState({ chooseYear: year, memoirList: [] }, async () => {
      await axios
        .get(
          `/gateway/api/demo-service/memoir/getbylist?year=${this.state.chooseYear}`
        )
        .then((res) => {
          let data = res.data.payload.sort((a, b) => b.month - a.month);
          this.setState({
            memoirList: data,
          });
        });
    });
  };

  render() {
    return (
      <div className="Home_Chronicles">
        <div className="Home_Chronicles_MainTitle">项目大事记</div>
        <div className="Home_Chronicles_time_title">
          {this.state.yearList[this.state.yearList.length - 1]}
          <span style={{ margin: "0 3px" }}>~</span>
          {this.state.yearList[0]}
        </div>
        <div className="Home_ChroniclesMain">
          <div className="Home_ChroniclesMain_Left">
            <div className="Home_ChroniclesMain_Left_Time_Line">
              {this.state.yearList.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={
                      this.state.chooseYear == item
                        ? "Home_ChroniclesMain_Left_Time_Line_Item Home_ChroniclesMain_Left_Time_Line_Item_Active"
                        : "Home_ChroniclesMain_Left_Time_Line_Item"
                    }
                    onClick={() => this.handleChange(item)}
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="Home_ChroniclesMain_Right">
            {this.state.memoirList.map((item, i) => {
              return (
                <div key={i} className="Home_ChroniclesMain_Right_Block">
                  <div className="Home_ChroniclesMain_Right_Block_Month">
                    <div className="Home_ChroniclesMain_Right_Block_Month_Text">
                      {item.month}月
                    </div>
                    <div className="Home_ChroniclesMain_Right_Block_Month_Line"></div>
                  </div>
                  <div className="Home_ChroniclesMain_Right_Block_content">
                    <div className="Home_ChroniclesMain_Right_Block_content_Item">
                      <span className="Home_ChroniclesMain_Right_Block_content_Item_Text">
                        {item.text}
                      </span>
                    </div>
                    <div className="Home_ChroniclesMain_Right_Block_content_Item">
                      <img
                        className="Home_ChroniclesMain_Right_Block_content_Item_Img"
                        src={item.picUrl}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
